import { apiPaths } from 'app/services/api';
import React from 'react';
import useExistingUser from 'app/hooks/useExistingUser';
import CrudGridForm from '../../smart-kit/Form/CrudGridForm';
import { MOBILE_REGEX } from '../../smart-kit/Form/gridFormUtils';

export const SellerFields = [
  // main
  {
    label: 'Mobile Number',
    type: 'number',
    key: 'mobile_number',
    validation: { required: true, pattern: MOBILE_REGEX },
    inputProps: { maxLength: 11 },
    watch: true
  },
  {
    label: 'Name',
    group: 'Name',
    groupIndex: 0,
    key: 'first_name',
    validation: { required: true }
  },
  {
    label: 'Last Name',
    group: 'Name',
    groupIndex: 1,
    key: 'last_name',
    validation: { required: true }
  },

  {
    label: 'Store',
    key: 'store_uuid',
    type: 'auto_complete',
    options: { entity: 'stores', path: apiPaths.STORES },
    auth: ['admin'],
    // show: { key: 'type', value: 'organisational' },
    validation: { required: true }
  },

  // { label: 'English Name', group: 'English Name', groupIndex: 0, key: 'eng_first_name', validation: { required: true } },
  // { label: 'English Last Name', group: 'English Name', groupIndex: 1, key: 'eng_last_name', validation: { required: true } },

  { label: 'Is Manager?', key: 'is_manager', validation: { required: false }, type: 'checkbox' },
  {
    label: 'Profile Pic',
    key: 'profile_pic',
    type: 'image',
    purpose: 'profile_pic',
    validation: { required: false }
  }
  // { label: 'National Card Pic', key: 'national_card_pic', type: 'image', purpose: 'national_card_pic', validation: { required: false } },

  // { label: 'Birth Date', key: 'birth_date', type: 'date', validation: { required: false } },
  // { label: 'Gender', key: 'gender', type: 'radio', items: [{ value: 'male', label: 'Male' }, { value: 'female', label: 'Female' }, { value: 'other', label: 'Other' }], validation: { required: false } },

  // { isTab: true, tabs: ['Contact Info', 'Additinal Info', 'Social Media', 'Bank Info'] },
  // // contact
  // { tab: 0, label: 'Whatsapp Number', key: 'contact_info.whatsapp_number', validation: { required: false } },
  // { tab: 0, label: 'Skype Id', key: 'contact_info.skype_id', validation: { required: false } },

  // // coach info
  // { tab: 1, group: 'Graduation', groupIndex: 0, label: 'Graduation Level', key: 'education.graduation_level', validation: { required: false } },
  // { tab: 1, group: 'Graduation', groupIndex: 1, label: 'Graduation Field', key: 'education.graduation_field', validation: { required: false } },

  // {
  //   tab: 1, group: 'Certification', groupIndex: 0, label: 'Certification Level', key: 'certification_level',
  //   type: 'select', items: [{ value: 'acc', label: 'ACC' }, { value: 'pcc', label: 'PCC' }, { value: 'mcc', label: 'MCC' }], validation: { required: true }
  // },

  // {
  //   tab: 1, group: 'Certification', groupIndex: 1, label: 'Coaching Graduation Level', key: 'coaching_graduation_level',
  //   type: 'select', items: [{ value: 'acsth', label: 'ACSTH' }, { value: 'actp', label: 'ACTP' }], validation: { required: false }
  // },
  // {
  //   tab: 1, label: 'Coach Expertise Field', key: 'expertise_field', type: 'selectMultiple',
  //   items: [{ value: 'organizational', label: 'Organizational' }, { value: 'business', label: 'Business' }, { value: 'life_style', label: 'Life Style' }, { value: 'executive_director', label: 'Executive Director' }, { value: 'managers', label: 'Managers' }],
  //   validation: { required: true },
  // },
  // { tab: 1, label: 'Coach Main Occupation', key: 'main_occupation', validation: { required: false } },
  // { tab: 1, label: 'Coach Description', type: 'multiline', key: 'description', validation: { required: false } },

  // social media
  // { tab: 2, label: 'Linkedin', key: 'social_media.linkedin', validation: { required: false } },
  // { tab: 2, label: 'Instagram', key: 'social_media.instagram', validation: { required: false } },
  // { tab: 2, label: 'Email', key: 'email', validation: { required: false } },
  // { tab: 2, label: 'Website', key: 'social_media.website', validation: { required: false } },

  // bank
  // { tab: 3, label: 'Bank Name', key: 'bank_info.bank_name', validation: { required: false } },
  // { tab: 3, label: 'Shaba Number', key: 'bank_info.shaba_number', validation: { required: false } },
];

const SellerForm = () => {
  const [defaultValues, onChange] = useExistingUser();

  return (
    <CrudGridForm
      path={apiPaths.SELLERS}
      name="Seller"
      entityName={'users'}
      fields={SellerFields}
      onChange={onChange}
      defaultValues={defaultValues}
    />
  );
};

export default SellerForm;
